(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    /* gb: counts down to data-end in days/hours/minutes/seconds (days drop out
     once under 24h). Stays hidden if the date doesn't parse; at zero it hides
     itself and shows the "after" text if there is one. */
  if (!customElements.get('gb-announcement-countdown')) {
    customElements.define(
      'gb-announcement-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end);
          if (Number.isNaN(this.end)) return;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const left = this.end - Date.now();
          const text = this.closest('.announcement-bar__text');

          if (left <= 0) {
            clearInterval(this.timer);
            this.hidden = true;
            text?.querySelector('[data-countdown-live]')?.setAttribute('hidden', '');
            text?.querySelector('[data-countdown-done]')?.removeAttribute('hidden');
            return;
          }

          const s = Math.floor(left / 1000);
          const parts = {
            days: Math.floor(s / 86400),
            hours: Math.floor((s % 86400) / 3600),
            minutes: Math.floor((s % 3600) / 60),
            seconds: s % 60,
          };

          for (const [unit, value] of Object.entries(parts)) {
            const el = this.querySelector(`[data-unit="${unit}"]`);
            if (!el) continue;
            if (unit === 'days') el.hidden = value === 0;
            const num = el.querySelector('.announcement-bar__countdown-num');
            const text = String(value).padStart(2, '0');
            if (num.textContent !== text) num.textContent = text;
          }
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
